import { ComponentWithRuntimeOpts, ApiForReact } from "@fusion/fusion/dist/output/Visonum.TsExport"
import React, { useEffect, useState } from "react"

type Props<P> = {
    componentWithRuntime: (opts: ComponentWithRuntimeOpts) => () => Promise<ApiForReact<P>>;
    halogenProps: P
}

type State<P> = {
    reactApi: ApiForReact<P> | null;
}

class Halogen<P> extends React.Component<Props<P>, State<P>> {
    private halogenRef: React.RefObject<HTMLInputElement>;

    // https://stackoverflow.com/questions/39767482/is-there-a-way-to-check-if-the-react-component-is-unmounted
    private isMounted: boolean;

    state: State<P> = {
        reactApi: null
    };

    constructor(props: Props<P>) {
        super(props);
        this.halogenRef = React.createRef();
        this.isMounted = false;
    }

    componentDidMount() {
        this.isMounted = true;

        console.log("CHARTFEAT: mount", this.halogenRef.current)

        if (this.halogenRef.current === null) return

        this.props.componentWithRuntime({
            mountElement: this.halogenRef.current
        })().then(reactApi => {
            if (this.isMounted) {
                this.setState({ reactApi })
            } else {
                reactApi.dispose()
            }
        })
    }

    componentWillUnmount() {
        this.isMounted = false;

        if (this.state.reactApi === null) {
            throw new Error("Memory Leak. React component unmounted before Halogen asynchronously provided the canceller..")
        } else {
            this.state.reactApi.dispose()
        }
    }

    static getDerivedStateFromProps(props: Props<unknown>, state: State<unknown>) {
        state.reactApi?.onNewProps(props.halogenProps)()
    }

    render() {

        return <div ref={this.halogenRef} />
    }


}

export default Halogen